import React from "react";

/**
 * Card with a title row, optional Edit button, and a Save/Cancel footer while `editing`.
 * Omit `onEdit` for read-only cards.
 */
export default function ProfileCard({ id, title, subtitle, editing = false, saving = false, onEdit, onCancel, onSave, children }) {
  return (
    <section className="pf-card" data-testid={`profile-card-${id}`} aria-labelledby={`pf-h-${id}`}>
      <div className="pf-ch">
        <div>
          <h2 id={`pf-h-${id}`}>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {onEdit && !editing && (
          <button type="button" className="pf-btn pf-btn-o pf-btn-sm" data-testid={`profile-edit-${id}`} onClick={onEdit}>
            Edit
          </button>
        )}
      </div>
      <div className="pf-cb">{children}</div>
      {editing && (
        <div className="pf-cf">
          <button type="button" className="pf-btn pf-btn-g pf-btn-sm" onClick={onCancel}>Cancel</button>
          <button type="button" className="pf-btn pf-btn-p pf-btn-sm" data-testid={`profile-save-${id}`} disabled={saving} onClick={onSave}>
            {saving ? "Saving…" : "Save changes"}
          </button>
        </div>
      )}
    </section>
  );
}

/** One label/value row inside a `.pf-dl` list. `htmlFor` ties the label to an input while editing. */
export function DetailRow({ label, htmlFor, children }) {
  return (
    <div>
      <dt>{htmlFor ? <label htmlFor={htmlFor}>{label}</label> : label}</dt>
      <dd>{children}</dd>
    </div>
  );
}

export const NotProvided = () => <span className="pf-em">Not provided</span>;
